// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Breakpoint untuk tablet 768px */
@media screen and (min-width: 768px) {
    main .hero {
      min-height: 30rem;
    }
    main #daftar-restoran {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
      gap: 0.5rem 2rem;
      padding-left: 15%;
      padding-right: 15%;
    }
    #daftar-restoran {
      min-height: 80vh;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI;MACE,iBAAiB;IACnB;IACA;MACE,aAAa;MACb,4DAA4D;MAC5D,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;EACF","sourcesContent":["/* Breakpoint untuk tablet 768px */\r\n@media screen and (min-width: 768px) {\r\n    main .hero {\r\n      min-height: 30rem;\r\n    }\r\n    main #daftar-restoran {\r\n      display: grid;\r\n      grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));\r\n      gap: 0.5rem 2rem;\r\n      padding-left: 15%;\r\n      padding-right: 15%;\r\n    }\r\n    #daftar-restoran {\r\n      min-height: 80vh;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
